<template>
  <div class="container-lg">
    <!-- Modal nuevo/editar -->
    <ModalBeneficio ref="modalBeneficio" :comercioFijo="comercioFijo" :comercioList="comercioList"
      :tiposCodigoList="tiposCodigoList" :permitePrioridad="permitePrioridad" :facade="facade" v-on:cerrado="modalCerrado"
      v-on:creado="creado" v-on:editado="editado" />
    <div v-show="!cargando">
      <div v-show="cantidad <= 0" class="alert alert-primary info-sin-elementos" role="alert">
        <p class="principal">No se encontraron beneficios</p>
        <p v-if="infoSinResultados" class="extra">{{ infoSinResultados }}</p>
      </div>
      <div v-show="cantidad > 0" id="tablaBeneficios" class="table-responsive">
        <!-- Teletransportador de arrastre -->
        <!-- Comentar codigo de funcionalidad de ordenamiento -->
        <!-- <div v-show="ordenando && HayPaginaAnterior" class="teletransportador">
          <span class="titulo">Arrastre aquí si quiere pasarlo a la página anterior</span>
          <table class="table">
            <draggable id="teletransportador-top" v-model="orden.teletransportadorTop" tag="tbody"
              :group="{ name: 'items', pull: false, put: true }" :sort="false">
              <Beneficio v-for="benef in orden.teletransportadorTop" v-bind:key="benef.id" :valor="benef" />
            </draggable>
          </table>
        </div> -->
        <table  class="table table-hover">
          <thead>
            <tr>
              <th v-if="MostrarAcciones">Acción</th>
              <th v-if="!comercioFijo">Comercio</th>
              <th>Descuento Estándar</th>
              <th>Nombre</th>
              <th>Prioridad</th>
              <th>Activo</th>
              <th>Días habilitados</th>
              <th>Medio de pago</th>
            </tr>
          </thead>
          <!-- Comentar codigo de funcionalidad de ordenamiento -->
          <!-- <draggable id="lista" v-model="lista" tag="tbody" :group="{ name: 'items', pull: true, put: false }"
            :sort="ordenando" handle=".arrastrador" @end="arrastreTerminado"> -->
          <!-- 
              :mostrarArrastre="ordenando"    
              :mostrarEditar="mostrarEditar && !ordenando"
              :mostrarEliminar="mostrarEliminar && !ordenando"
              en <Beneficio>
            -->
          <Beneficio v-for="benef in lista" v-bind:key="benef.id" class="fila" :comercioFijo="comercioFijo"
            :mostrarEditar="mostrarEditar" :mostrarEliminar="mostrarEliminar" :valor="benef"
            v-on:editar="clickEditar(benef)" v-on:eliminar="clickEliminar(benef)" />
          <!-- </draggable> -->
        </table>
        <!-- Comentar codigo de funcionalidad de ordenamiento -->
        <!-- Teletransportador de arrastre -->
        <!-- <div v-show="ordenando && HayPaginaSiguiente" class="teletransportador">
          <span class="titulo">Arrastre aquí si quiere pasarlo a la página siguiente</span>
          <table class="table">
            <draggable id="teletransportador-bot" v-model="orden.teletransportadorBot" tag="tbody"
              :group="{ name: 'items', pull: false, put: true }" :sort="false">
              <Beneficio v-for="benef in orden.teletransportadorBot" v-bind:key="benef.id" :valor="benef" />
            </draggable>
          </table>
        </div> -->
      </div>
      <Paginacion ref="paginacion" :cantidad="cantidad" :cantidadPorPagina="CantidadPorPagina" :paginaInicial="pagina"
        v-on:pagina-cambiada="paginaCambiada" />
    </div>
    <div v-show="cargando" class="spinner-border" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>
</template>

<script>
// Comentar codigo de funcionalidad de ordenamiento
//import draggable from "vuedraggable";
import Swal from "sweetalert2";

//import { Api } from "../../../api";
import Beneficio from "./util/Beneficio";
import ModalBeneficio from "../modals/ModalBeneficio";
import { Paginacion as ConstantesPaginacion } from "../../../constants";
import Paginacion from "../../Paginacion";
import { Util } from "../../../util";

/** Cuando se empezó a editar */
const EVENTO_EDITAR = "editar";
/** Cuando se terminó de editar */
const EVENTO_EDITADO = "editado";
const EVENTO_ELIMINADO = "eliminado";

export default {
  components: {
    // Comentar codigo de funcionalidad de ordenamiento
    //draggable,

    Beneficio,
    ModalBeneficio,
    Paginacion
  },
  props: {
    busqueda: Object,
    // Si está en verdadero, no se realizarán cargas automáticas
    // Ejemplo en el mounted hook o cuando cambia la búsqueda
    cargaManual: Boolean,
    /** Cuando todos los beneficios mostrados son del mismo comercio */
    comercioFijo: {
      type: Boolean,
      default: false
    },
    comercioList: Array,
    /** Utilizada para cargar y guardar datos */
    facade: Function,
    // Información extra mostrada cuando no se encontraron resultados
    infoSinResultados: String,
    // Muestra u oculta los botones de acción
    mostrarEditar: Boolean,
    mostrarEliminar: Boolean,

    // Comentar codigo de funcionalidad de ordenamiento
    // Cuando se está en modo ordenar
    //ordenando: Boolean,

    // Usado para saber si se ordenará en un futuro
    //puedeOrdenar: Boolean,
    tiposCodigoList: Array,
    permitePrioridad: Boolean,
  },
  data() {
    return {
      /** Cantidad en el server */
      cantidad: 0,
      cargando: true,
      lista: [],
      // orden: {
      //   // Los teletransportadores son usados para mover items entre paginas
      //   teletransportadorTop: [],
      //   teletransportadorBot: []
      // },
      pagina: 1,
    };
  },
  computed: {
    CantidadPorPagina() {
      return ConstantesPaginacion.BENEFICIOS_POR_PAGINA;
    },
    HayPaginaAnterior() {
      return this.pagina > 1;
    },
    HayPaginaSiguiente() {
      return this.pagina * this.CantidadPorPagina < this.cantidad;
    },
    MostrarAcciones() {
      return this.mostrarEditar || this.mostrarEliminar; //|| this.ordenando
    }
  },
  watch: {
    busqueda() {
      if (!this.cargaManual) this.recargar();
    }
  },
  methods: {
    // Los métodos con "Evento" adelante son llamados desde afuera, si se cambia su interface, hay que cambiar afuera
    // Cuando se quiere empezar a crear
    EventoCrear() {
      this.$refs.modalBeneficio.EventoAbrir();
    },
    EventoRecargar(busqueda) {
      this.recargar(busqueda);
    },

    // ---------- Metodos privados -----------

    // Comentar codigo de funcionalidad de ordenamiento
    // aplicarOrdenEnServidor(
    //   item,
    //   { itemAnterior = null, itemSiguiente = null }
    // ) {
    //   Api.Beneficio.ordenar(item.id, {
    //     atrasDeId: itemSiguiente ? itemSiguiente.id : null,
    //     delanteDeId: itemAnterior ? itemAnterior.id : null
    //   }).then(response => {
    //     /** Lista de prioridades cambiadas donde cada elemento es un {idBeneficio, prioridadNueva} */
    //     const listaCambios = response.data;

    //     /** Lista con todos los beneficios mostrados */
    //     const listaTodos = [
    //       ...this.orden.teletransportadorTop,
    //       ...this.lista,
    //       ...this.orden.teletransportadorBot
    //     ];

    //     // Cambiar las prioridades de los elementos locales para coincidir con las del servidor
    //     listaCambios.forEach(cambio => {
    //       const local = listaTodos.find(b => b.id == cambio.id);

    //       if (local) local.prioridad = cambio.prioridad;
    //     });
    //   });
    // },
    // aplicarOrdenDeLista(evento) {
    //   const nuevoIndice = evento.newIndex;

    //   // Item arrastrado
    //   const item = this.lista[nuevoIndice];

    //   // Si no se ordenó al principio
    //   if (nuevoIndice > 0)
    //     this.aplicarOrdenEnServidor(item, {
    //       itemAnterior: this.lista[nuevoIndice - 1]
    //     });
    //   else {
    //     // Si se está en una pagina que no es la primera, informar que queda delante del item de la página anterior
    //     if (this.pagina > 1)
    //       this.aplicarOrdenEnServidor(item, {
    //         itemAnterior: this.orden.teletransportadorTop[0]
    //       });
    //     // Se está en la primera página y se mueve al principio
    //     else this.aplicarOrdenEnServidor(item, { itemAnterior: null });
    //   }
    // },
    // arrastreTerminado(evento) {
    //   switch (evento.to.id) {
    //     case "lista":
    //       // Solo aplicar orden si se movió de su lugar
    //       if (evento.newIndex != evento.oldIndex)
    //         this.aplicarOrdenDeLista(evento);
    //       break;
    //     case "teletransportador-top":
    //       this.teletransportar(evento);
    //       break;
    //     case "teletransportador-bot":
    //       this.teletransportar(evento, true);
    //       break;
    //     default:
    //       break;
    //   }
    // },
    cargar(busqueda = this.busqueda) {
      this.cargando = true;
      // Parámetros de paginación
      let desde = Util.paginacionCalcularDesde(this.pagina, this.CantidadPorPagina);
      let hasta = Util.paginacionCalcularHasta(this.pagina, this.CantidadPorPagina);

      // Si es posible que se ordene en un futuro, se piden elementos extras
      // Comentar codigo de funcionalidad de ordenamiento

      // if (this.puedeOrdenar) {
      //   // Pedir un elemento de la página anterior
      //   if (this.HayPaginaAnterior) desde--;
      //   // Pedir un elemento de la pagina siguiente
      //   if (this.HayPaginaSiguiente) hasta++;
      // }

      this.facade
        .getListWithFilter({
          busqueda,
          desde,
          hasta,
          idComercio: this.idComercio
        })
        .then(response => {
          let datos = response.data;

          // Si se pidieron items extras para trabajar con orden
          // Tener en cuenta que el arreglo datos será modificado

          // Comentar codigo de funcionalidad de ordenamiento
          // if (this.puedeOrdenar) {
          //   this.recortarDatosDeOrden(datos);
          // }

          this.lista = datos;
          this.cargando = false;
        });
    },
    clickEditar(item) {
      // Abrir modal de edición
      this.$refs.modalBeneficio.EventoAbrir(item);

      // Informar que se empezó a editar
      this.$emit(EVENTO_EDITAR, item);
    },
    clickEliminar(item) {
      Swal.fire({
        title: "Atención!",
        text:
          "Está seguro que desea eliminar este beneficio? Se eliminarán todas las suscripciones asociadas",
        icon: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Si, eliminar",
        cancelButtonText: "No",
        preConfirm: () => {
          return this.facade
            .deleteById(item.id)
            .then(() => {
              this.eliminado(item);
            })
            .catch(() => {
              Swal.showValidationMessage(
                "Ocurrió un error al eliminar el beneficio"
              );
            });
        }
      }).then(result => {
        if (result.isConfirmed) {
          Swal.fire(
            "Confirmación",
            "El beneficio se ha eliminado con éxito",
            "success"
          );
        }
      });
    },
    // Cuando un item fue creado
    creado() {
      this.cantidad++;
      this.cargar();
    },
    // Cuando se guardó la edición de un item
    editado(item) {
      // TODO: solo cargar cuando el item queda fuera de la página
      this.cargar();

      // Avisar que se editó un item
      this.$emit(EVENTO_EDITADO, item);
    },
    eliminado(item) {
      this.$emit(EVENTO_ELIMINADO, item);

      this.cantidad--;
      this.cargar();
    },
    // Cuando se cierra el modal de creación/edición
    modalCerrado() { },
    paginaCambiada(numero) {
      this.pagina = numero;
      this.cargar();
      // Scrollear al principio de la tabla
      Util.scrollearAId("tablaBeneficios", true);
    },
    recargar(busqueda = this.busqueda) {
      this.cargando = true;
      this.pagina = 1;
      this.lista = [];

      this.facade
        .countWithFilter({
          busqueda,
          idComercio: this.idComercio
        })
        .then(respuesta => {
          this.cantidad = respuesta.data;

          if (this.cantidad > 0) this.cargar(busqueda);
          else this.cargando = false;
        });
    },

    // Comentar codigo de funcionalidad de ordenamiento
    //   recortarDatosDeOrden(datos) {
    //     if (this.HayPaginaAnterior) {
    //       const elementoPaginaAnterior = datos[0];

    //       // Sacar elemento de la lista mostrada
    //       Util.eliminarElemento(datos, elementoPaginaAnterior);

    //       // Inicializar teletransportador de orden
    //       this.orden.teletransportadorTop = [elementoPaginaAnterior];
    //     }

    //     if (this.HayPaginaSiguiente) {
    //       const elementoPaginaSiguiente = datos[datos.length - 1];
    //       Util.eliminarElemento(datos, elementoPaginaSiguiente);
    //       this.orden.teletransportadorBot = [elementoPaginaSiguiente];
    //     }
    //   },
    //   // Cuando se quiere arrastrar un item a otra pagina
    //   /**
    //    * @param {*} abajo indica si es el teletransportador de abajo o de arriba
    //    */
    //   teletransportar(evento, abajo = false) {
    //     // Obtener el teletransportador correspondiente
    //     const teletransportador = abajo
    //       ? this.orden.teletransportadorBot
    //       : this.orden.teletransportadorTop;

    //     // Item agregado al teletransportador (se va a otra página)
    //     // Este item estaba siendo mostrado en la lista hasta ahora
    //     const item = teletransportador[evento.newIndex];

    //     // Item de la otra pagina (que estaba en el teletransportador)
    //     const itemSacado = teletransportador.find(i => i != item);

    //     // Sacar de teletransportador
    //     Util.eliminarElemento(teletransportador, itemSacado);

    //     // Agregar item de la pagina siguiente al final de la lista
    //     if (abajo) this.lista.push(itemSacado);
    //     // Agregar item de la pagina anterior al principio de la lista
    //     else this.lista.unshift(itemSacado);

    //     // Aplicar orden en servidor
    //     let itemAnterior = null;

    //     // Ya que el item arrastrado pasará a estar delante del item teletransportado
    //     if (abajo) itemAnterior = itemSacado;

    //     // Si hay item anterior, pasarlo
    //     if (itemAnterior)
    //       this.aplicarOrdenEnServidor(item, {
    //         itemAnterior: itemAnterior
    //       });
    //     // Si no hay item anterior, significa que el item sacado es el siguiente,
    //     // informar que se está pasando el siguiente
    //     else
    //       this.aplicarOrdenEnServidor(item, {
    //         itemSiguiente: itemSacado
    //       });
    //   }
  },
  mounted() {
    if (!this.cargaManual) this.recargar();
  }
};
</script>

<style lang="scss" scoped>
.teletransportador .titulo {
  font-size: 18px;
}
</style>
